import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Statistics } from '../../types';

interface StatisticsCardProps {
  title: string;
  statistics: Statistics;
  color?: 'primary' | 'secondary' | 'success' | 'error';
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({ 
  title, 
  statistics, 
  color = 'primary' 
}) => {
  const getWinRateColor = (winRate: number) => {
    if (winRate >= 70) return 'success.main';
    if (winRate >= 50) return 'warning.main';
    return 'error.main';
  };

  return (
    <Card elevation={2}>
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          {title}
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">
              総試合数
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {statistics.totalMatches}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">
              勝利数
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="success.main">
              {statistics.wins}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">
              敗北数
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="error.main">
              {statistics.losses}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 1, borderTop: 1, borderColor: 'divider' }}>
            <Typography variant="body1" fontWeight="bold">
              勝率
            </Typography>
            <Typography 
              variant="h6" 
              fontWeight="bold" 
              color={getWinRateColor(statistics.winRate)}
            >
              {statistics.winRate.toFixed(1)}%
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatisticsCard;